import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {Link, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import "../../assets/css/pages/admins.css";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#seller').DataTable({
      "destroy": true,
      "ajax": {
        url: `${baseUrl}sellers`,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        {data: 'id', name: 'id'},
        {data: 'first_name', name: 'first_name'},
        {data: 'last_name', name: 'last_name'},
        {data: 'email', name: 'email'},
        {data: 'phone', name: 'phone'},
        {
          data: 'is_active',
          name: 'is_active',
          render: function (data, type, row) {
            return row.is_active ? 'Active' : 'Inactive';
          }
        },
        {
          data: 'actions',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      order: [[0, "desc"]],
    });

    table.on('click', 'button.actions', function () {
      $(this).next(".row-actions").fadeToggle().toggleClass("hidden-actions")
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/sellers/${id}/edit`);
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);

  return (
    <div>
      <div className="d-flex flex-stack mb-5">
        <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
          <Link to='/sellers/create'
                className="btn btn-primary"
          >
            Add Seller
          </Link>
        </div>
      </div>
      <table id="seller" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>ID</th>
          <th>Firstname</th>
          <th>Lastname</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  );
}